export default __webpack_public_path__ + "static/media/github-battle.643abc85.jpg";